var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkiconlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Library > Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.50294 9.14584L3.48211 17.4933C3.51253 17.76 3.78753 18 4.07128 18H15.9279C16.2104 18 16.4867 17.7575 16.5175 17.4933L17.4967 9.14584C17.5188 8.95626 17.4071 8.83334 17.1967 8.83334H2.80294C2.59336 8.83334 2.48086 8.95793 2.50294 9.14584ZM0.847528 9.34001C0.708361 8.15376 1.60336 7.16668 2.80294 7.16668H17.1971C18.3963 7.16668 19.2921 8.15084 19.1525 9.34001L18.1734 17.6875C18.0434 18.7967 17.0513 19.6667 15.9284 19.6667H4.0717C2.94794 19.6667 1.95711 18.7996 1.82669 17.6875L0.847528 9.34001ZM4.1667 5.91668C3.94568 5.91668 3.73372 5.82888 3.57744 5.6726C3.42116 5.51632 3.33336 5.30436 3.33336 5.08334C3.33336 4.86233 3.42116 4.65037 3.57744 4.49409C3.73372 4.33781 3.94568 4.25001 4.1667 4.25001H15.8334C16.0544 4.25001 16.2663 4.33781 16.4226 4.49409C16.5789 4.65037 16.6667 4.86233 16.6667 5.08334C16.6667 5.30436 16.5789 5.51632 16.4226 5.6726C16.2663 5.82888 16.0544 5.91668 15.8334 5.91668H4.1667ZM6.25003 3.00001C6.02901 3.00001 5.81705 2.91221 5.66077 2.75593C5.50449 2.59965 5.4167 2.38769 5.4167 2.16668C5.4167 1.94566 5.50449 1.7337 5.66077 1.57742C5.81705 1.42114 6.02901 1.33334 6.25003 1.33334H13.75C13.971 1.33334 14.183 1.42114 14.3393 1.57742C14.4956 1.7337 14.5834 1.94566 14.5834 2.16668C14.5834 2.38769 14.4956 2.59965 14.3393 2.75593C14.183 2.91221 13.971 3.00001 13.75 3.00001H6.25003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkiconlight);
export default __webpack_public_path__ + "static/media/bulkiconlight.b6faa84147006c3855848cfbb49968ee.svg";
export { ForwardRef as ReactComponent };